module.exports = __webpack_public_path__ + "img/20210906-1630898414144066.31b67f4d.jpg";